import backgroundImg from './background.jpg';
import logoElectric from './logo-mob.svg';
export { logoElectric, backgroundImg };
